import Row from '../col/src/row'

Row.install = app => {
  app.component(Row.name, Row)
}

export default Row

declare module 'vue' {
    export interface GlobalComponents {
        PtRow: typeof Row;
    }
}
